import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { motion } from 'framer-motion';

// Components
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Summary from './components/Summary';
import Experience from './components/Experience';
import Educations from './components/Educations';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Certification from './components/Certifications'; // Corrected spelling
import Contact from './components/Contact';

function App() {
  const [theme, setTheme] = React.useState('dark');

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    document.body.className = `${theme}-theme`;
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <Header toggleTheme={toggleTheme} theme={theme} />
      <main className="section-wrapper">
        {[
          ['home', <Home />],
          ['about', <About />],
          ['summary', <Summary />],
          ['experience', <Experience />],
          ['educations', <Educations />],
          ['projects', <Projects />],
          ['skills', <Skills />],
          ['certification', <Certification />],
          ['contact', <Contact />],
        ].map(([id, Component], index) => (
          <motion.section
            id={id}
            className="section"
            key={id}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.05 }}
            variants={fadeIn}
          >
            <div className="container-custom">
              {Component}
            </div>
          </motion.section>
        ))}
      </main>
    </>
  );
}

export default App;
